import { render, staticRenderFns } from "./ProductListItem.vue?vue&type=template&id=12405278&scoped=true&"
import script from "./ProductListItem.vue?vue&type=script&lang=js&"
export * from "./ProductListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductListItem.vue?vue&type=style&index=0&id=12405278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12405278",
  null
  
)

export default component.exports